import { render, staticRenderFns } from "./property-test.vue?vue&type=template&id=273f838e&"
import script from "./property-test.vue?vue&type=script&lang=js&"
export * from "./property-test.vue?vue&type=script&lang=js&"
import style0 from "./property-test.vue?vue&type=style&index=0&id=273f838e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports